import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GpdButtonComponent } from "../gpd-button/gpd-button.component";

@Component({
    selector: "app-details-panel-shell",
    imports: [CommonModule, GpdButtonComponent],
    templateUrl: "./details-panel-shell.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./details-panel-shell.component.css"]
})
export class DetailsPanelShellComponent {
  @Input() visible: boolean = false;
  @Input() title: string = $localize`:@@details:Details`;
  @Input() showEditButton: boolean = true;

  @Output() onClose = new EventEmitter<void>();
  @Output() onEdit = new EventEmitter<void>();
}
